export const addRequiredLabelSymbol = (inputLabel: string) => `${inputLabel} *`;

export const removeNumberDecoration = (input: string): number => +input.replace(/\D/g, '');

export const isEmpty = (copy: string) => copy === undefined || copy.trim() === '';
